function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.85038 22H18.1496C20.7316 22 22 20.7325 22 18.1975V3.80247C22 1.26749 20.7316 0 18.1496 0H3.85038C1.28346 0 0 1.26749 0 3.80247V18.1975C0 20.7325 1.28346 22 3.85038 22ZM3.88058 19.8121C2.79341 19.8121 2.17433 19.2387 2.17433 18.0919V3.90809C2.17433 2.77641 2.79341 2.18793 3.88058 2.18793H18.1194C19.2066 2.18793 19.8257 2.77641 19.8257 3.90809V18.0919C19.8257 19.2387 19.2066 19.8121 18.1194 19.8121H3.88058ZM9.5429 16.8999C9.99588 16.8999 10.3583 16.6886 10.6301 16.2661L16.2924 7.30316C16.4736 7.04664 16.6246 6.74486 16.6246 6.44307C16.6246 5.82442 16.0961 5.44719 15.5223 5.44719C15.175 5.44719 14.8428 5.65844 14.5861 6.06584L9.4825 14.3045L6.96088 10.9246C6.65889 10.5171 6.3267 10.3663 5.96431 10.3663C5.37543 10.3663 4.92244 10.8491 4.92244 11.4376C4.92244 11.7394 5.04324 12.0261 5.22443 12.2675L8.38023 16.2661C8.74262 16.7037 9.08991 16.8999 9.5429 16.8999Z"
});

var SvgTick = function SvgTick(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22",
      fill: "none"
    }, props), _ref)
  );
};

export default SvgTick;